export const GET_GENERE_VALUES = 'GET_GENERE_VALUES'
export const GET_GENERE_VALUES_LOADING = 'GET_GENERE_VALUES_LOADING'
export const GET_GENERE_VALUES_SUCCESS = 'GET_GENERE_VALUES_SUCCESS'
export const GET_GENERE_VALUES_FAILURE = 'GET_GENERE_VALUES_FAILURE'
export const GET_GENERE_VALUES_UNLOAD = 'GET_GENERE_VALUES_UNLOAD'

export const loadGenereValues = (
  categoryId,
  q = '',
  crossFilters = {},
  posseduto
) => ({
  type: GET_GENERE_VALUES,
  payload: { categoryId, q, crossFilters, posseduto },
})

export const unloadGenereValues = categoryId => ({
  type: GET_GENERE_VALUES_UNLOAD,
  payload: { categoryId },
})



// WEBPACK FOOTER //
// ./src/actions/genereValues.js